import Vue from "vue";
import VueResource from "vue-resource";

import { API_ROOT, API_ROOT_V2, API_ROOT_V3, edc, packet, formschedules, forms, schedule, formversions, participantschedule, formresponse, unscheduledpackets, unscheduledpacketresponse, studies, participants, responses, sourceDocuments, preSignedUpload, preSignedDownload, notification } from "./urls";

Vue.use(VueResource);

const edcFormScheduleResource = Vue.resource(`${API_ROOT}${edc}/${formschedules}`, {}, { update: { method: "PUT" } });

const edcFormScheduleResourceList = Vue.resource(`${API_ROOT_V2}${edc}/${formschedules}`, {}, { update: { method: "PUT" } });

const edcFormResource = Vue.resource(`${API_ROOT}${edc}/${forms}{/formId}`, {}, { update: { method: "PUT" } });

const edcFormResourceV2 = Vue.resource(`${API_ROOT_V2}${edc}/${forms}{/formId}`, {}, { update: { method: "PUT" } });

const edcFormResourceV3 = Vue.resource(`${API_ROOT_V3}${edc}/${forms}{/formId}`, {}, { update: { method: "PUT" } });

const edcformversionsResource = Vue.resource(`${API_ROOT}${edc}/${forms}{/formId}/${formversions}`, {}, { update: { method: "PUT" } });

const edcformversionResource = Vue.resource(`${API_ROOT}${edc}/${forms}{/mainFormId}/${formversions}/{formId}`, {}, { update: { method: "PUT" } });

const activityformversionResource = Vue.resource(`${API_ROOT_V2}${edc}/${forms}{/mainFormId}/${formversions}/{formId}`, {}, { update: { method: "PUT" } });

const activityformversionResourceV3 = Vue.resource(`${API_ROOT_V3}${edc}/${forms}{/mainFormId}/${formversions}/{formId}`, {}, { update: { method: "PUT" } });

const edcFormMilestoneResource = Vue.resource(`${API_ROOT_V2}${edc}/${forms}/${schedule}`, {}, { head: { method: "HEAD" } }, { update: { method: "PUT" } });

const participantScheduleResource = Vue.resource(`${API_ROOT}${edc}/${participantschedule}{/pId}`, {}, { update: { method: "PUT" } });

const edcFormResponseResource = Vue.resource(`${API_ROOT}${edc}/${forms}{/formId}/${formresponse}`, {}, { update: { method: "PUT" } });

const edcFormResponseResourceV2 = Vue.resource(`${API_ROOT_V2}${edc}/${forms}{/formId}/${formresponse}`, {}, { update: { method: "PUT" } });

const edcFormResponseResourceV3 = Vue.resource(`${API_ROOT_V3}${edc}/${forms}{/formId}/${formresponse}`, {}, { update: { method: "PUT" } });

const edcFormResponseFormResource = Vue.resource(`${API_ROOT}${edc}/${forms}{/formId}/${formresponse}/{responseId}`, {}, { update: { method: "PUT" } });

const edcFormResponseFormResourceV2 = Vue.resource(`${API_ROOT_V2}${edc}/${forms}{/formId}/${formresponse}/{responseId}`, {}, { update: { method: "PUT" } });

const edcFormResponseFormResourceV3 = Vue.resource(`${API_ROOT_V3}${edc}/${forms}{/formId}/${formresponse}/{responseId}`, {}, { update: { method: "PUT" } });

const edcUnscheduleResource = Vue.resource(`${API_ROOT}${edc}/${unscheduledpackets}{/packetId}`, {}, { update: { method: "PUT" } });

const edcUnscheduleV2Resource = Vue.resource(`${API_ROOT_V2}${edc}/${unscheduledpackets}{/packetId}`, {}, { update: { method: "PUT" } });

const edcUnscheduleV3Resource = Vue.resource(`${API_ROOT_V3}${edc}/${unscheduledpackets}{/packetId}`, {}, { update: { method: "PUT" } });

const edcUnschedulePacketResponseResource = Vue.resource(`${API_ROOT}${edc}/${unscheduledpackets}{/packetId}/${unscheduledpacketresponse}`, {}, { update: { method: "PUT" } });

const edcUnschedulePacketFormResponseResource = Vue.resource(`${API_ROOT}${edc}/${unscheduledpackets}{/packetId}/${unscheduledpacketresponse}/{packetResponseId}`, {}, { update: { method: "PUT" } });

const edcUnschedulePacketFormResponseResourceV2 = Vue.resource(`${API_ROOT_V2}${edc}/${unscheduledpackets}{/packetId}/${unscheduledpacketresponse}/{packetResponseId}`, {}, { update: { method: "PUT" } });

const edcUnschedulePacketFormResponseResourceV3 = Vue.resource(`${API_ROOT_V3}${edc}/${unscheduledpackets}{/packetId}/${unscheduledpacketresponse}/{packetResponseId}`, {}, { update: { method: "PUT" } });

const edcUnschedulePacketResource = Vue.resource(`${API_ROOT}${edc}/${unscheduledpackets}{/packetId}`, {}, { update: { method: "PUT" } });

const preSignedUrlResource = Vue.resource(`${API_ROOT}${edc}/${studies}{/studyId}/${participants}{/participantId}/${responses}{/responseId}/${sourceDocuments}/${preSignedUpload}`, {}, { update: { method: "PUT" } });

const postUploadResource = Vue.resource(`${API_ROOT}${edc}/${studies}{/studyId}/${participants}{/participantId}/${responses}{/responseId}/${sourceDocuments}`, {}, { update: { method: "PUT" } });

const downloadUrlResource = Vue.resource(`${API_ROOT}${edc}/${studies}{/studyId}/${participants}{/participantId}/${responses}{/responseId}/${sourceDocuments}{/id}/${preSignedDownload}`, {}, { update: { method: "PUT" } });

const deleteDocumentResource = Vue.resource(`${API_ROOT}${edc}/${studies}{/studyId}/${participants}{/participantId}/${responses}{/responseId}/${sourceDocuments}{/id}`, {}, { update: { method: "PUT" } });

const getUnschduledPktsList = Vue.resource(`${API_ROOT}${edc}/${unscheduledpackets}`, {}, { update: { method: "PUT" } });

const activityMilestoneResource = Vue.resource(`${API_ROOT_V2}${edc}/${packet}/${schedule}`, {}, { head: { method: "HEAD" } }, { update: { method: "PUT" } });

// add and update notification
const saveConfigureActiviytNotification = Vue.resource(`${API_ROOT}${edc}/${notification}/${forms}{/formId}?studyId={studyId}`, {}, { update: { method: "PUT" } });

const saveConfigureActiviytNotificationV2 = Vue.resource(`${API_ROOT_V2}${edc}/${notification}/${forms}{/formId}?studyId={studyId}`, {}, { update: { method: "PUT" } });

// delete notification
const deleteConfigureActiviytNotification = Vue.resource(`${API_ROOT}${edc}/${notification}/${forms}{/formId}?questionId={questionId}&studyId={studyId}&notificationId={notificationId}`, {}, { update: { method: "PUT" } });

const deleteConfigureActivityNotificationV2 = Vue.resource(`${API_ROOT_V2}${edc}/${notification}/${forms}{/formId}?questionId={questionId}&studyId={studyId}&notificationId={notificationId}`, {}, { update: { method: "PUT" } });

export function postScheduleActivityPacketFact(studyId, packetId, data) {
  return activityMilestoneResource.save({ studyId, packetId }, data);
}

export function getScheduleActivityPacketFact(studyId, packetId) {
  return activityMilestoneResource.get({ studyId, packetId });
}
export function updateScheduleActivityPacketFact(studyId, packetId, data) {
  return activityMilestoneResource.update({ studyId, packetId }, data);
}

export function getEDCFormsFact(studyId) {
  return edcFormScheduleResource.get({ studyId });
}

export function getEDCFormsList(studyId) {
  return edcFormScheduleResourceList.get({ studyId });
}

export function getEDCFormDataFact(formId, studyId) {
  return edcFormResource.get({ studyId, formId });
}

export function getEDCFormDataFactV2(formId, studyId) {
  return edcFormResourceV2.get({ studyId, formId });
}

export function getEDCformversionsDataFact(formId, studyId) {
  return edcformversionsResource.get({ studyId, formId });
}

export function getEDCformversionDataFact(mainFormId, formId, studyId) {
  return edcformversionResource.get({ studyId, formId, mainFormId });
}

export function postEDCFormFact(studyId, data) {
  return edcFormResource.save({ studyId }, data);
}

export function updateEDCFormDataFact(formId, studyId, isFormChanged, data) {
  return edcFormResource.update({ studyId, formId, isFormChanged }, data);
}

export function removeFormV2(formId, studyId) {
  return edcFormResourceV2.delete({ formId, studyId }, {});
}

export function getEDCFormDataFactV3(formId, studyId) {
  return edcFormResourceV3.get({ studyId, formId });
}

export function removeFormV3(formId, studyId) {
  return edcFormResourceV3.delete({ formId, studyId }, {});
}

export function pushEdcFormVersionLive(formId, studyId, payload = {}) {
  return edcFormResourceV3.update({ formId, studyId }, payload);
}

export function getEDCMilestonesFact(studyId, formId) {
  return edcFormMilestoneResource.get({ studyId, formId });
}

export function postEDCMilestonesFact(studyId, formId, data) {
  return edcFormMilestoneResource.save({ studyId, formId }, data);
}

export function updateEDCMilestonesFact(studyId, formId, data) {
  return edcFormMilestoneResource.update({ studyId, formId }, data);
}

export function getParticipantFormsFact(studyId, pId) {
  return participantScheduleResource.get({ studyId, pId });
}

export function getEDCFormResponseFact(formId, studyId, participantId, milestone) {
  return edcFormResponseResource.get({
    studyId,
    formId,
    participantId,
    milestone
  });
}

export function postEDCFormResponseFact(formId, studyId, participantId, data) {
  return edcFormResponseResource.save({ studyId, formId, participantId }, data);
}

export function postEDCFormResponseFactV2(formId, studyId, participantId, requestId, data) {
  return edcFormResponseResourceV2.save({ studyId, formId, participantId, requestId }, data);
}

export function postEDCFormResponseFactV3(formId, studyId, participantId, requestId, data) {
  return edcFormResponseResourceV3.save({ studyId, formId, participantId, requestId }, data);
}

export function updateEDCFormResponseFact(formId, studyId, participantId, responseId, data) {
  return edcFormResponseFormResource.update({ studyId, formId, participantId, responseId }, data);
}

export function updateEDCFormResponseFactV2(formId, studyId, participantId, responseId, data) {
  return edcFormResponseFormResourceV2.update({ studyId, formId, participantId, responseId }, data);
}

export function getEDCFormResponseByResponseIdFact(formId, studyId, participantId, responseId, milestone) {
  return edcFormResponseFormResource.get({
    studyId,
    formId,
    participantId,
    responseId,
    milestone
  });
}

export function getEDCFormResponseByResponseIdFactV2(formId, studyId, participantId, responseId, milestone) {
  return edcFormResponseFormResourceV2.get({
    studyId,
    formId,
    participantId,
    responseId,
    milestone
  });
}

export function updateEDCFormResponseFactV3(formId, studyId, participantId, responseId, data) {
  return edcFormResponseFormResourceV3.update({ studyId, formId, participantId, responseId }, data);
}

export function getEDCFormResponseByResponseIdFactV3(formId, studyId, participantId, responseId, milestone) {
  return edcFormResponseFormResourceV3.get({
    studyId,
    formId,
    participantId,
    responseId,
    milestone
  });
}

export function getUnscheduledPacketsFact(studyId) {
  return edcUnscheduleResource.get({ studyId });
}

export function getUnscheduledPacketFactV2(packetId, studyId) {
  return edcUnscheduleV2Resource.get({ packetId, studyId });
}

export function getUnscheduledPacketFactV3(packetId, studyId) {
  return edcUnscheduleV3Resource.get({ packetId, studyId });
}

// API with new version V3
export function getUnscheduledPacketNewFactV3(studyId) {
  return edcUnscheduleV3Resource.get({ studyId });
}

export function removePacketV3(packetId) {
  return edcUnscheduleV3Resource.delete({ packetId });
}

export function getUnscheduledPacketFact(studyId, packetId) {
  return edcUnschedulePacketResource.get({ studyId, packetId });
}

export function postUnscheduledPacketFact(studyId, data) {
  return edcUnscheduleResource.save({ studyId }, data);
}

export function getPacketFact(studyId, packetId) {
  return edcUnscheduleResource.get({ studyId, packetId });
}

export function editPacketNameFact(studyId, packetId, data) {
  return edcUnscheduleResource.update({ studyId, packetId }, data);
}

export function checkEDCMilestonesFact(studyId) {
  return edcFormMilestoneResource.head({ studyId });
}

export function postEDCUnscheduleFormResponseFact(packetId, studyId, participantId, data) {
  return edcUnschedulePacketResponseResource.save({ studyId, packetId, participantId }, data);
}

export function updateEDCUnscheduleFormResponseFact(packetId, studyId, participantId, packetResponseId, data) {
  return edcUnschedulePacketFormResponseResource.update({ studyId, packetId, participantId, packetResponseId }, data);
}

export function getEDCUnscheduleFormResponseFact(studyId, participantId) {
  return edcUnschedulePacketResponseResource.get({ studyId, participantId });
}

export function getUnscheduleFormResponseFact(studyId, participantId, packetId, packetResponseId) {
  return edcUnschedulePacketFormResponseResource.get({
    studyId,
    participantId,
    packetId,
    packetResponseId
  });
}

export function getPreSignedUrlFact(studyId, participantId, responseId, type, siteId) {
  return preSignedUrlResource.get({
    studyId,
    participantId,
    responseId,
    type: type,
    siteId: siteId
  });
}

export function postUploadFact(studyId, participantId, responseId, data, siteId) {
  return postUploadResource.save({ studyId, participantId, responseId, siteId: siteId }, data);
}

export function getSourceDocumentsFact(studyId, participantId, responseId, siteId) {
  return postUploadResource.get({
    studyId,
    participantId,
    responseId,
    siteId: siteId
  });
}

export function getDownloadUrlFact(studyId, participantId, responseId, id, siteId) {
  return downloadUrlResource.get({
    studyId,
    participantId,
    responseId,
    id,
    siteId: siteId
  });
}

export function deleteDocumentFact(studyId, participantId, responseId, id, siteId) {
  return deleteDocumentResource.delete({
    studyId,
    participantId,
    responseId,
    id,
    siteId: siteId
  });
}

export function getUnschduledPkts(studyId) {
  return getUnschduledPktsList.get({ studyId });
}

const activityFormResource = Vue.resource(`${API_ROOT_V2}${edc}/${forms}{/formId}`, {}, { update: { method: "PUT" } });

const activityFormResourceV3 = Vue.resource(`${API_ROOT_V3}${edc}/${forms}{/formId}`, {}, { update: { method: "PUT" } });

export function postActivityFormToStudy(studyId, data) {
  return activityFormResource.save({ studyId }, data);
}

export function getActivityFormData(formId, studyId) {
  return activityFormResource.get({ studyId, formId });
}

export function postActivityFormToStudyV3(studyId, data) {
  return activityFormResourceV3.save({ studyId }, data);
}

export function getActivityFormDataV3(formId, studyId) {
  return activityFormResourceV3.get({ studyId, formId });
}

export function postUnscheduledPacketFactV2(studyId, data) {
  return edcUnscheduleV2Resource.save({ studyId }, data);
}

export function updateUnscheduledPacketFactV2(packetId, studyId, data) {
  return edcUnscheduleV2Resource.update({ packetId, studyId }, data);
}

export function getActivityformversionDataFact(mainFormId, formId, studyId) {
  return activityformversionResource.get({ studyId, formId, mainFormId });
}

export function getActivityformversionDataFactV3(mainFormId, formId, studyId) {
  return activityformversionResourceV3.get({ studyId, formId, mainFormId });
}

export function updateEDCUnscheduleFormResponseFactV2(packetId, studyId, participantId, packetResponseId, data) {
  return edcUnschedulePacketFormResponseResourceV2.update({ studyId, packetId, participantId, packetResponseId }, data);
}

export function postEDCUnscheduleFormResponseFactV2(packetId, studyId, participantId, data) {
  return edcUnschedulePacketFormResponseResourceV2.save({ studyId, packetId, participantId }, data);
}

export function getUnscheduleFormResponseFactV2(studyId, participantId, packetId, packetResponseId) {
  return edcUnschedulePacketFormResponseResourceV2.get({
    studyId,
    participantId,
    packetId,
    packetResponseId
  });
}

export function updateEDCUnscheduleFormResponseFactV3(packetId, studyId, participantId, packetResponseId, data) {
  return edcUnschedulePacketFormResponseResourceV3.update({ studyId, packetId, participantId, packetResponseId }, data);
}

export function postEDCUnscheduleFormResponseFactV3(packetId, studyId, participantId, requestId, data) {
  return edcUnschedulePacketFormResponseResourceV3.save({ studyId, packetId, participantId, requestId }, data);
}

export function getUnscheduleFormResponseFactV3(studyId, participantId, packetId, packetResponseId) {
  return edcUnschedulePacketFormResponseResourceV3.get({
    studyId,
    participantId,
    packetId,
    packetResponseId
  });
}

// add and update notification
export function addActivityNotificationFact(studyId, formId, payload) {
  return saveConfigureActiviytNotification.save({ studyId, formId }, payload);
}

// get notification
export function getEDCNotificationFact(studyId, formId) {
  return saveConfigureActiviytNotification.get({ studyId, formId });
}

export function addActivityNotificationFactV2(studyId, formId, payload) {
  return saveConfigureActiviytNotificationV2.save({ studyId, formId }, payload);
}

// get notification
export function getEDCNotificationFactV2(studyId, formId) {
  return saveConfigureActiviytNotificationV2.get({ studyId, formId });
}

// delete notification
export function deleteEDCNotificationFact(studyId, questionId, notificationId, formId) {
  return deleteConfigureActiviytNotification.delete({
    studyId,
    questionId,
    notificationId,
    formId
  });
}

export function deleteEDCNotificationFactV2(studyId, questionId, notificationId, formId) {
  return deleteConfigureActivityNotificationV2.delete({
    studyId,
    questionId,
    notificationId,
    formId
  });
}
